import { useState, useRef } from "react";
import { toast } from "sonner";
import { api, resolveImg } from "@/lib/api";
import { UploadCloud, Loader2 } from "lucide-react";

export const ImageUpload = ({ value, onChange, label, className = "" }) => {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Imagen subida");
    } catch {
      toast.error("Error al subir la imagen");
    } finally {
      setLoading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className={className}>
      {label && <label className="text-xs uppercase tracking-widest text-neutral-400">{label}</label>}
      <div className="mt-2 flex items-center gap-4">
        <div className="h-20 w-20 shrink-0 rounded-xl overflow-hidden border border-white/10 bg-[#0A0A0A] flex items-center justify-center">
          {value ? (
            <img src={resolveImg(value)} alt="preview" className="h-full w-full object-cover" />
          ) : (
            <UploadCloud size={22} className="text-neutral-600" />
          )}
        </div>
        <div className="flex-1 space-y-2">
          <button
            type="button"
            data-testid="upload-trigger"
            onClick={() => inputRef.current?.click()}
            disabled={loading}
            className="inline-flex items-center gap-2 rounded-full border border-white/15 hover:border-[#FF5A00] px-4 py-2 text-sm font-semibold transition disabled:opacity-60"
          >
            {loading ? <Loader2 size={15} className="animate-spin" /> : <UploadCloud size={15} />}
            Subir imagen
          </button>
          <input
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder="o pega una URL"
            className="w-full rounded-lg bg-[#0A0A0A] border border-white/10 px-3 py-2 text-xs focus:border-[#FF5A00] focus:outline-none"
          />
        </div>
        <input ref={inputRef} type="file" accept="image/*" onChange={handle} className="hidden" />
      </div>
    </div>
  );
};
